export function flattenProductsData(product) {
    const {
        clearanceMemoContractualParties = [],
        productComments = [],
        ...nonArrayFields
    } = product;

    function flatten(obj, prefix = '', res = {}) {
        for (const key in obj) {
            if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                flatten(obj[key], `${prefix}${key}.`, res);
            } else {
                res[`${prefix}${key}`] = obj[key];
            }
        }
        return res;
    }

    const base = flatten(nonArrayFields);
    const baseKeys = Object.keys(base);
    const partyKeys = clearanceMemoContractualParties[0]
        ? Object.keys(
              flatten(clearanceMemoContractualParties[0], 'clearanceMemoContractualParties.'),
          )
        : [];

    const commentKeys = productComments[0]
        ? Object.keys(
              flatten(
                  {
                      ...productComments[0],
                      attachments: undefined,
                  },
                  'productComments.',
              ),
          ).filter((k) => k !== 'productComments.attachments')
        : [];
    const firstCommentAttachments = productComments[0]?.attachments || [];
    const attachmentKeys = firstCommentAttachments[0]
        ? Object.keys(flatten(firstCommentAttachments[0], 'productComments.attachments.'))
        : [];

    const getArrayFields = (item, prefix, allKeys) => {
        if (!item) {
            return Object.fromEntries(allKeys.map((k) => [k, '']));
        }
        return flatten(item, prefix);
    };
    const getCommentFields = (comment, allKeys) => {
        if (!comment) return Object.fromEntries(allKeys.map((k) => [k, '']));
        const { attachments, ...rest } = comment;
        return flatten(rest, 'productComments.');
    };
    const getEmptyBase = () => Object.fromEntries(baseKeys.map((k) => [k, '']));

    const maxRows = Math.max(
        clearanceMemoContractualParties.length,
        productComments.length,
        firstCommentAttachments.length,
        1,
    );
    const rows = [];

    for (let i = 0; i < maxRows; i++) {
        const baseFields = i === 0 ? base : getEmptyBase();
        const partyFields = getArrayFields(
            clearanceMemoContractualParties[i],
            'clearanceMemoContractualParties.',
            partyKeys,
        );
        const commentFields = getCommentFields(productComments[i], commentKeys);
        const attachmentFields = getArrayFields(
            firstCommentAttachments[i],
            'productComments.attachments.',
            attachmentKeys,
        );

        if (
            Object.values(partyFields).some((v) => v) ||
            Object.values(commentFields).some((v) => v) ||
            Object.values(attachmentFields).some((v) => v)
        ) {
            rows.push({
                ...baseFields,
                ...partyFields,
                ...commentFields,
                ...attachmentFields,
            });
        }
    }

    return rows;
}